import { IRole } from '@app/models/role.interface';
import { Action, createReducer, on } from '@ngrx/store';
import * as RoleActions from '../actions/role.actions';

export const roleFeatureKey = 'role';

export interface State {
  roles: IRole[],
  me: IRole,
  currentPage: number,
  total: number,
  sortType: string
  direction: string,
  pageSize: number,
  error_message: any
}

export const initialState: State = {
  roles: [],
  me: null,
  total: 0,
  currentPage: 0,
  sortType: 'roleNameEn',
  direction: 'DESC',
  pageSize: 100,
  error_message: null
};

export const reducer = createReducer(
  initialState,

  on(RoleActions.loadRoles, state => ({
    ...state,
    isLoading: true
  })),
  on(RoleActions.loadRolesSuccess, (state, action) => ({
    ...state,
    roles: action.roles,
    total: action.total
  })),
  on(RoleActions.loadRolesFailure, (state, action) => state),
  on(RoleActions.loadRole, state => state),
  on(RoleActions.loadRoleSuccess, (state, action) => ({
    ...state,
    role: action.role
  })),
  on(RoleActions.loadRolesFailure, (state, action) => state),
  on(RoleActions.saveRoleSuccess, (state, { role }) => ({
    ...state,
    roles: [role, ...state.roles]
  })),
  on(RoleActions.DeleteRoleShowErrorMessage, (state, action) => ({
    ...state,
    error_message: action
})),
  on(RoleActions.AssignNewRoles, (state, action) => ({
    ...state,
    message: action
})),
  on(RoleActions.updateRoleSuccess, (state, { role }) => ({
    ...state,
    roles: state.roles.map((item)=> {
      if(item.roleID == role.roleID){
        return role
      }else{
        return item
      }
    }),
  })),
  on(RoleActions.deleteRole, state => state),
  on(RoleActions.deleteRoleSuccess, (state, action) => ({
    ...state,
    roles: state.roles.filter(x => x.roleID != action.id)
  })),
  on(RoleActions.sortRoles, (state, action) => ({
    ...state,
  })),

  on(RoleActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(RoleActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(RoleActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(RoleActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(RoleActions.resetRole, (state, action) => ({ 
    ...state,
    role: null
  })),
);

// function quickSort(array, type){
//   if (array.length <= 1) {
//     return array;
//   }

//   var pivot = array[0];
  
//   var left = []; 
//   var right = [];

//   for (var i = 1; i < array.length; i++) {
//     array[i].type < pivot.type ? left.push(array[i]) : right.push(array[i]);
//   }

//   return quickSort(left, type).concat(pivot, quickSort(right, type));

// }